<div class="view-content" [ngClass]="{ 'fullscreen': fullscreen, 'centered-view': centered ,'view-content': true, 'no-padding': nopadding}"  [style.paddingBottom]="'calc(' + Layout.actionAreaHeight + 'px + var(--nav-total))'">
  <ng-content></ng-content>
</div>
